const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError']

export default events



// WEBPACK FOOTER //
// ./src/components/upload/common/file-events.js